import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["input", "preview", "existingImages", "orderField"]

  connect() {
    // 編集フォーム: 登録済み画像をドラッグ&ドロップで並び替え可能にする
    if (this.hasExistingImagesTarget) {
      this._existingSortable = Sortable.create(this.existingImagesTarget, {
        animation: 150,
        ghostClass: "sortable-ghost",
        onEnd: () => this._updateOrderFields(),
      })
    }
  }

  disconnect() {
    this._existingSortable?.destroy()
    this._newSortable?.destroy()
  }

  preview() {
    this.previewTarget.innerHTML = ""
    const files = this.inputTarget.files
    if (files.length === 0) return

    Array.from(files).forEach((file, index) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const wrap = document.createElement("div")
        wrap.className = "preview-item"
        wrap.dataset.index = index

        const img = document.createElement("img")
        img.src = e.target.result
        wrap.appendChild(img)
        this.previewTarget.appendChild(wrap)

        // 全ファイルのプレビューが揃ったらSortableを初期化
        if (this.previewTarget.children.length === files.length) {
          this._initNewSortable()
        }
      }
      reader.readAsDataURL(file)
    })
  }

  _initNewSortable() {
    this._newSortable?.destroy()
    this._newSortable = Sortable.create(this.previewTarget, {
      animation: 150,
      ghostClass: "sortable-ghost",
      onEnd: () => this._rebuildFileInput(),
    })
  }

  // 並び替え後にDataTransfer APIでinput.filesをDOM順に再構築
  _rebuildFileInput() {
    const items = Array.from(this.previewTarget.children)
    const originalFiles = Array.from(this.inputTarget.files)
    const dt = new DataTransfer()
    items.forEach(item => dt.items.add(originalFiles[parseInt(item.dataset.index)]))
    this.inputTarget.files = dt.files
  }

  // 既存画像の並び替え後にblob IDのhidden fieldsをDOM順で再生成
  _updateOrderFields() {
    this.orderFieldTargets.forEach(f => f.remove())
    Array.from(this.existingImagesTarget.children).forEach(item => {
      const hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = "post[image_order][]"
      hidden.value = item.dataset.blobId
      hidden.setAttribute("data-image-upload-target", "orderField")
      this.element.appendChild(hidden)
    })
  }
}
